<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import Label from "../../components/Form/Label.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import {
    filter,
    loading,
    records,
    pagination,
    initList,
    onCreate,
    onEdit,
    onDelete,
    onPageChange,
    search,
    onCustomersFilterClick,
    onSuppliersFilterClick,
    onCarriersFilterClick,
  } from "./customer.store";
  import { customerFields } from "../../utils/TableFields/customer.fields";
  import { isUserRoleADM } from "../../app.store";

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="anagrafica"
    entityPlural="anagrafiche"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  >
    <div slot="search" class="level-item customer-search-box">
      <div style="min-width: 20rem; margin-left: 3rem;">
        <div class="field has-addons">
          <p class="control">
            <button class="button {$filter.criteria.customersOnly == 1 ? 'is-primary' : ''}" on:click={(_) => onCustomersFilterClick()}>
              <span>Clienti</span>
            </button>
          </p>
          <p class="control">
            <button class="button {$filter.criteria.suppliersOnly == 1 ? 'is-primary' : ''}" on:click={(_) => onSuppliersFilterClick()}>
              <span>Fornitori</span>
            </button>
          </p>
          <p class="control">
            <button class="button {$filter.criteria.carriersOnly == 1 ? 'is-primary' : ''}" on:click={(_) => onCarriersFilterClick()}>
              <span>Vettori</span>
            </button>
          </p>
        </div>
      </div>
      <div style="min-width: 5rem;">
        <Label>Mostra cancellati</Label>
      </div>
      <div style="min-width: 5rem;">
        <Switch name="" bind:value={$filter.criteria.showAll} on:toggle={search} />
      </div>
    </div>
  </SearchHeader>

  <Table
    loading={$loading}
    fields={customerFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={$isUserRoleADM}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>

<style>
  .customer-search-box {
    display: flex;
    flex-direction: row;
  }
  .customer-search-box div {
    padding-right: 0.75rem;
  }
</style>
